import { z } from 'zod'
import { type Expand } from '@/types/ui/expand'

// Allowed file types
const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PPTX
  'image/jpeg',
  'image/jpg', 
  'image/png'
]

// Max file size (10MB in bytes)
const MAX_FILE_SIZE = 10 * 1024 * 1024

// Document upload form schema
export const documentUploadSchema = z.object({
  documentName: z.string().min(1, 'Field is required').max(255, 'Field must be less than 255 characters'),
  file: z.custom<File>((val) => val instanceof File, 'Please select a file')
    .refine((file) => file.size <= MAX_FILE_SIZE, 'File size must be less than 10MB')
    .refine(
      (file) => ALLOWED_FILE_TYPES.includes(file.type),
      'File type not supported. Please upload PDF, DOCX, XLSX, PPTX, JPG, or PNG files'
    )
})

// Automatically infer the TypeScript type from the schema
export type DocumentUploadFormData = Expand<z.infer<typeof documentUploadSchema>>

// Export constants for use in components
export { ALLOWED_FILE_TYPES, MAX_FILE_SIZE } 